<div class="modal-container">
  <div class="header">
    <span class="header-copy">{{ data.title }}</span>
    <button
      mat-icon-button
      (click)="onCloseClick()"
      [disabled]="submitting"
    >
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
  <ng-container *ngIf="!loading; else loadingTemplate">
    <ng-container *ngIf="!loadingError; else loadingErrorTemplate">
      <ng-container [formGroup]="partnerForm">
        <div class="subheader">
          <div class="partner-form">
            <div class="field-label">Customer</div>
            <div class="field-container">
              <mat-form-field
                class="field subscripts"
                appearance="outline"
                color="primary"
              >
                <mat-select
                  disableOptionCentering
                  panelClass="disable-option-centering-select-panel"
                  formControlName="partnerId"
                >
                  <mat-option
                    *ngFor="let partner of partners"
                    [value]="partner.partnerId"
                    >{{ partner.partnerId }} - {{ partner.partnerName }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
              <button
                mat-icon-button
                color="accent"
                [disableRipple]="true"
                (click)="onRefreshUsersClick()"
              >
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="body merri-scrollbar-gray">
          <ng-container *ngIf="!loadingUsers; else loadingUsersTemplate">
            <ng-container *ngIf="!loadingUsersError; else loadingUsersErrorTemplate">
              <ng-container *ngIf="partnerForm.controls['partnerId'].value; else noPartnerSelectedTemplate">
                <ng-container *ngIf="userData.allUsers.length; else noPartnerUsersFoundTemplate">
                  <ts-checkbox-list
                    [data-all-items]="userData.allUsers"
                    formControlName="selectedUsers"
                    data-selected-prop="userId"
                    [searchFn]="usersSearch"
                  >
                    <ng-template
                      #checkboxTemplate
                      let-context
                    >
                      <div class="checkbox-data">
                        <span class="name">{{ context.fullName }}</span>
                        <span class="email">{{ context.email }}</span>
                      </div>
                    </ng-template>
                  </ts-checkbox-list>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
      <div class="footer">
        <div class="messages">
          <span
            class="submit-error"
            *ngIf="submitError"
            >{{ submitError }}</span
          >
          <span
            class="submit-success"
            *ngIf="submitSuccess"
            >Changes saved successfully</span
          >
        </div>
        <div class="actions">
          <span
            class="selected-count"
            *ngIf="!loadingUsers"
          >
            {{ selectedUsersFormControl.value.length }} / {{ userData?.allUsers?.length }} selected
          </span>
          <button
            *ngIf="!partnerForm.controls.selectedUsers.pristine && !submitting"
            mat-flat-button
            color="primary"
            (click)="onDiscardChanges()"
            [disabled]="submitting"
          >
            Discard Changes
          </button>
          <button
            mat-stroked-button
            color="secondary"
            [disabled]="submitting"
            (click)="onCloseClick()"
          >
            Close
          </button>
          <button
            class="button-save"
            mat-flat-button
            color="accent"
            [disabled]="partnerForm.controls.selectedUsers.pristine || submitting"
            (click)="onSaveClick()"
          >
            <ng-container *ngIf="!submitting">Save</ng-container>
            <merri-loading-spinner
              [loading]="true"
              [color]="primary"
              *ngIf="submitting"
            ></merri-loading-spinner>
          </button>
          <button
            class="button-save"
            mat-flat-button
            color="accent"
            [disabled]="partnerForm.controls.selectedUsers.pristine || submitting"
            (click)="onSaveClick(true)"
          >
            <ng-container *ngIf="!submitting">Save & Close</ng-container>
            <merri-loading-spinner
              [loading]="true"
              [color]="primary"
              *ngIf="submitting"
            ></merri-loading-spinner>
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #loadingTemplate>
  <div class="spinner">
    <mat-progress-spinner
      color="accent"
      mode="indeterminate"
      strokeWidth="10"
      diameter="75"
    >
    </mat-progress-spinner>
  </div>
</ng-template>

<ng-template #loadingErrorTemplate>
  <div class="error-container">
    <app-error-with-refresh
      [error]="loadingError"
      (refresh)="onLoadingRefreshClick()"
    ></app-error-with-refresh>
  </div>
</ng-template>

<ng-template #loadingUsersTemplate>
  <div class="spinner">
    <mat-progress-spinner
      color="accent"
      mode="indeterminate"
      strokeWidth="10"
      diameter="75"
    >
    </mat-progress-spinner>
  </div>
</ng-template>

<ng-template #loadingUsersErrorTemplate>
  <div class="error-container">
    <app-error-with-refresh
      [error]="loadingUsersError"
      (refresh)="onLoadingUsersRefreshClick()"
    ></app-error-with-refresh>
  </div>
</ng-template>

<ng-template #noPartnerSelectedTemplate>
  <div class="no-data-message">No customer selected. Please select a customer to view linked users.</div>
</ng-template>

<ng-template #noPartnerUsersFoundTemplate>
  <div class="no-data-message">This customer has no users. Go to Prod Support to create them.</div>
</ng-template>
